var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Box from "../../box/Box";
import Text from "../../text";
export function getActivePromoDiscountConfig(pid, promoDiscountConfigs) {
    return promoDiscountConfigs.find(function (promoConfig) {
        return promoConfig.eligible_promo_product_ids.includes(pid) ||
            promoConfig.eligible_discount_product_ids.includes(pid);
    });
}
var PromoDiscount = function (_a) {
    var promoDiscountConfig = _a.promoDiscountConfig, rest = __rest(_a, ["promoDiscountConfig"]);
    return (React.createElement(Box, __assign({}, rest, { p: 5, borderRadius: 4, border: "2px solid", borderColor: "riverTeals.6", bg: "riverTeals.0" }),
        React.createElement(Text, { display: "block", fontWeight: "heavy", color: "riverTeals.6", as: "p", fontSize: 3, mb: 3, dangerouslySetInnerHTML: { __html: promoDiscountConfig.title } }),
        React.createElement(Text, { typeStyle: "body", fontSize: 1, color: "grays.6", dangerouslySetInnerHTML: { __html: promoDiscountConfig.description } })));
};
export default PromoDiscount;
//# sourceMappingURL=PromoDiscount.js.map